import Box from "@mui/material/Box";
import React from "react";
import { ComponentStyles } from "../../models/app";
import { Palette } from "../palette/Palette";
import "reactflow/dist/style.css";
import ScoreBoard from "../scoreboard/ScoreBoard";
import BlockCanvas from "./BlockCanvas";

const styles: ComponentStyles = {
  canvas: {
    width: "100vw",
    height: "100vh",
    //position: "relative",
    backgroundColor: "#fff",
    backgroundImage: `linear-gradient(#9fc5e8 1.5px, transparent 1.5px), linear-gradient(90deg, #9fc5e8 1.5px, transparent 1.5px), linear-gradient(#cfe2f3 1px, transparent 1px), linear-gradient(90deg, #cfe2f3 1px, transparent 1px)`,
    backgroundPosition: "-1.5px -1.5px, -1.5px -1.5px, -1px -1px, -1px -1px",
    backgroundSize: "100px 100px, 100px 100px, 20px 20px, 20px 20px",
  },
};

export const Canvas: React.FC = () => {
  const classes = styles;

  return (
    <>
      <Box style={classes.canvas}>
        <ScoreBoard />
        <BlockCanvas />
      </Box>
      <Palette />
    </>
  );
};
